import PageHead from "@components/Components/Reusables/PageHead";
import BoxContainer from "@components/Components/Reusables/BoxContainerV2";
import RenderSections from "@components/Components/Reusables/RenderSections";
import { getSections, parseGridString } from "@components/config/helpers";
import { useTemplatePageContent } from "@components/Components/Providers/TemplatePageContentContext";
import PageTitle from "@components/Components/Reusables/PageTitle";
import ParseHtml from "@components/Custom/ParseHtml";
import Divider from "@mui/material/Divider";

export const hasHtmlTags = (value) => {
    return typeof value === 'string' && /<\/?[a-z][\s\S]*>/i.test(value);
};


const StaticPage = (props) => {
    const {
        template_page_settings,
        sx = {},
        spacing = 2,
        mobileClasses = ""
    } = props;

    // const { template_settings, agent} = useSelector((state) => state.globalReducer);
    // const { isMobile } = agent;
    // const screensize = useWindowSize();

    const { template_page_content, meta } = useTemplatePageContent();
    const page_content = template_page_content;
    const sections = getSections(template_page_content);
    const title = page_content?.page_title?.content || page_content?.page_title?.title;
    const gridProps = template_page_settings?.page_grid ? parseGridString(template_page_settings.page_grid) : {
        xs: 12,
        lg: 6
    }

    return (
        <>
            <PageHead
                title={meta.meta_title}
                description={meta.meta_description}
                ogTitle={meta.og_title}
                ogDescription={meta.og_description}
                ogType={meta.og_type}
                ogUrl={meta.og_url}
                ogImage={meta.og_image}
                ogSiteName={meta.og_site_name}
            />
            <BoxContainer
                className="mt-2 mb-6 fs-18"
                template_page_settings={template_page_settings}
                sx={sx}
                mobileClasses={mobileClasses}
            >
                {hasHtmlTags(page_content.page_title?.title) ? <ParseHtml html={title} /> : <PageTitle component="h1" className="mb-5 text-center uppercase">{title}</PageTitle>}
                <Divider className="mb-4" />
                {/* {page_content.page_title && (
                <>
                    <ParseHtml html={title}/>
                    <Divider className="mb-4 mt-4"/>
                </>
            )} */}

                <RenderSections
                    spacing={spacing}
                    sections={sections}
                    gridProps={gridProps}
                />

            </BoxContainer>
        </>

    )
}

export default StaticPage